import React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, CollapseProps, List } from 'antd';
import RepoHeader from './RepoHeader';
import ListItem from './ListItem';
import { IRepoProjectStore } from '../store/RepoProject';
import { IProps } from '../types';

interface IAccordionProps extends IProps {
  projects: any[];
  store: IRepoProjectStore;
}

function RepoAccordion({
  id,
  name,
  type,
  lastError,
  successDate,
  url,
  projectsNum,
  activeProjectsNum,
  projectErrors,
  projects,
  store,
  isDisabled,
}: IAccordionProps) {
  const repoKey = String(id);
  const isOpen = store.isAccordionOpen(repoKey);
 
  const handleAccordionChange = (keys: string[] | string) => {
    const openKeys = Array.isArray(keys) ? keys : [keys];
    const isNowOpen = openKeys.includes(repoKey);
    store.setAccordionState(repoKey, isNowOpen);
  };

  const items: CollapseProps['items'] = [
    {
      key: repoKey,
      label: (
        <RepoHeader
          id={id}
          name={name}
          type={type}
          lastError={lastError}
          url={url}
          projectsNum={projectsNum}
          activeProjectsNum={activeProjectsNum}
          successDate={successDate}
          projectErrors={projectErrors}
          isDisabled={isDisabled}
        />
      ),
      children: (
        <List
          bordered
          dataSource={projects}
          pagination={{
            current: store.currentPage[repoKey] ?? 1,
            pageSize: 5,
            align: 'start',
            showSizeChanger: false,
            onChange: (page) => {
              store.setCurrentPage(repoKey, page);
            },
          }}
          renderItem={(project) => <ListItem project={project} />}
        />
      ),
    },
  ];

  return (
    <Collapse
      items={items}
      activeKey={isOpen ? [repoKey] : []}
      onChange={handleAccordionChange}
    />
  );
}

export default observer(RepoAccordion);
